var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-sheet',{attrs:{"height":"400","width":"200%","color":"greeen lighten-2"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }